import React, { Component } from "react";
import { PageHeader, message, Modal, Alert, Tabs, Spin } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, MensajeError, fmtFechaDia } from "../../../../Components/Items";
import ModalReingreso from "../Reingreso/ModalReingreso";
import { QuestionCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import ConfiguracionFiniquito from "./ConfiguracionFiniquito";
import DesgloseFiniquito from "./DesgloseFiniquito";
import GuiaFiniquito from "./GuiaFiniquito";
import ModalValidacionTimbrado from "../ModalValidacionTimbrado/ModalValidacionTimbrado";
// El mismo modal de cancelación de Prenómina: cancelar el recibo de un finiquito es cancelar el
// de su línea, y ese camino ya está probado (incluidos los dos CFDI de un recibo partido).
import CancelarCfdiNomina from "../../PreNomina/CancelarCfdiNomina/CancelarCfdiNomina";
// Y el mismo visor de recibos: PDF, XML y el selector entre los DOS comprobantes de un finiquito
// partido ya viven ahí. Toma `empresaId` y `headersToken` de redux, así que sólo pide la línea.
import ModalReciboNomina from "../../PreNomina/ModalReciboNomina/ModalReciboNomina";
import SelectorFechaEmision, {
  fechaEmisionPorDefecto, errorFechaEmision, formatoFechaEmision,
} from "../../../../Components/SelectorFechaEmision";

const { TabPane } = Tabs;

// Copia sin una llave — los importes forzados son un objeto plano indexado por conceptoNominaId.
const sinLlave = (obj, llave) => {
  const copia = { ...(obj || {}) };
  delete copia[llave];
  return copia;
};

/**
 * Pantalla de finiquito, con el flujo de CONTPAQi Nóminas:
 *
 *   Capturar la baja → Calcular (propone días, se pueden alterar) → Aplicar finiquito
 *
 * "Calcular" corre el motor real de nómina en modo simulación: los importes, el gravado, el
 * exento y el ISR que se ven son los definitivos, pero no se escribe nada. "Aplicar finiquito"
 * mete los conceptos en la línea del empleado dentro de la prenómina del periodo elegido.
 *
 * El TIMBRADO no ocurre aquí: la línea se timbra desde Prenómina junto con el resto de la
 * gente, como cualquier otra.
 */
class Finiquito extends Component {
  state = {
    // La URL manda; el state del router es el respaldo para los enlaces viejos. Al revés, un F5
    // dejaba la pantalla sin empleado y sin forma de recuperarlo.
    empleadoId: this.props.match?.params?.empleadoId || this.props.location.state?.id || null,
    empleado: null,
    causas: [],
    conceptosFaltantes: [],
    // Datos que le faltan a la ficha del empleado (SBC, salario diario). No impiden calcular
    // —el motor corre y devuelve importes en 0.00— así que se muestran junto al resultado y
    // apagan Aplicar, que es lo que escribiría un finiquito en ceros imposible de editar.
    basesFaltantes: [],
    finiquitoPrevio: null,

    // Paso 1 — datos de la baja
    fechaBaja: moment(),
    causaFiniquito: "renuncia",
    motivoBaja: "",
    aniosCompletosIsr: null,

    // Paso 2 — periodo de aplicación. Se cargan solos al capturar la fecha de baja, con una
    // consulta que NO corre el motor; el cálculo es el paso 3 y lo dispara el usuario.
    periodos: [],
    periodoAplicacionId: null,
    motivoPeriodos: null,

    // Conceptos capturados: { [key]: { aplica, dias } }
    conceptos: {},

    // Conceptos LIBRES: los que el usuario eligió del catálogo para este finiquito, con su
    // importe capturado. [{ conceptoNominaId, descripcion, tipo, importe, aplica }]
    extras: [],

    // Importes forzados en la pestaña de cálculos —la edición tipo sobre-recibo—:
    // { [conceptoNominaId]: { importeTotalManual?, valorManual? } }. Viven aparte de `conceptos`
    // porque `calcular()` rehidrata ése desde la respuesta y éstos se reenvían en cada corrida.
    manuales: {},

    // Resultado del cálculo
    preview: null,

    // Prenóminas que la baja dejó desactualizadas. No se tocan desde aquí: `porRecalcular` son
    // las que el usuario tiene que recalcular desde Prenómina, y `advertencias` las que ya no
    // se pueden arreglar así (cerradas o timbradas).
    porRecalcular: [],
    advertencias: [],

    cargando: false,
    cargandoPeriodos: false,
    agregandoALaPrenomina: false,
    dandoDeBaja: false,
    calculando: false,
    aplicando: false,
    timbrando: false,
    deshaciendo: false,
    aplicado: false,
    timbrado: false,
    // Un finiquito aplicado se sigue ajustando hasta que se timbra. Lo resuelve el backend
    // (`desgloseFiniquito`) mirando el estatus del finiquito, el de la línea y el de la
    // prenómina, para que la pantalla no tenga que adivinar la misma regla por su cuenta.
    editable: false,
    // Por qué no se pudo leer el desglose de un finiquito aplicado. Va en el estado y no como
    // toast: sin esto, la pantalla de un finiquito roto se ve igual que la de uno que no existe.
    errorDesglose: null,
    // Fecha de pago de la liquidación: la que manda en la póliza y en el @FechaPago del CFDI.
    // Vacía = se usa la de la prenómina, que es el comportamiento de siempre.
    fechaPago: null,
    // La contabilización es append-only: en cuanto la póliza existe, su fecha ya no se mueve.
    polizaGenerada: false,
    fechaRegistroPoliza: null,
    numeroPoliza: null,
    advertenciasFechaPago: [],
    cancelarVisible: false,
    reciboVisible: false,
    guiaVisible: false,
    uuid: null,
    // El UUID del segundo comprobante: un finiquito con pagos por separación se timbra en dos
    // CFDI (el ordinario y el de régimen 13). Ver Utils/divisionFiniquito.utils.js.
    uuidSeparacion: null,
    // Se reusa el mismo modal de validación del listado de Empleados.
    validacion: { visible: false, loading: false, resultados: [] },
    // Confirmación del timbrado. Era un Modal.confirm imperativo, pero ahora
    // tiene que sostener el DatePicker de la fecha de emisión como valor
    // controlado, y un confirm no puede.
    confirmarTimbrado: { visible: false, fecha: null },
    reingresoVisible: false,
    tab: "1",
  };

  componentDidMount() {
    this.cargarDatos();
  }

  // ── Carga inicial ────────────────────────────────────────────────────────
  async cargarDatos() {
    const { empresaId, headersToken } = this.props;
    const { empleadoId } = this.state;
    if (!empleadoId) {
      message.error("No se recibió el empleado. Entra desde el listado de Empleados.");
      return;
    }

    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "nomina/datosParaFiniquito",
        { empresaId, empleadoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        const { empleado, causas, conceptosFaltantes, finiquito } = res.data;
        this.setState({
          empleado,
          causas,
          conceptosFaltantes: conceptosFaltantes || [],
          finiquitoPrevio: finiquito,
          // Si la baja ya estaba capturada (finiquito aplicado o proceso a medias) se
          // precarga, para que se pueda consultar o continuar en lugar de empezar de cero.
          fechaBaja: empleado.fechaBaja ? moment(empleado.fechaBaja) : moment(),
          causaFiniquito: empleado.causaFiniquito || "renuncia",
          motivoBaja: empleado.motivoBaja || "",
          aplicado: !!(finiquito && finiquito.estatus !== "deshecho"),
          timbrado: finiquito?.estatus === "timbrado",
        });
        // Un finiquito ya aplicado trae su desglose de la línea: sin esto la pantalla se abría
        // en blanco (nada rehidrataba la previsualización) y no había nada que ajustar.
        if (finiquito && finiquito.estatus !== "deshecho") {
          this.cargarDesgloseAplicado(finiquito._id);
        }
        // Con baja capturada y sin finiquito VIGENTE se cargan los periodos para que retome
        // donde se quedó. NO se calcula solo — el cálculo es el paso 3 y lo dispara el usuario.
        //
        // La condición mira `aplicado`, no `finiquito`: un finiquito en estatus "deshecho" es
        // truthy, así que con `!finiquito` los periodos no cargaban nunca después de deshacer
        // uno. Con el finiquito tardío ese caso pasa a ser frecuente, porque deshacerlo deja la
        // fecha de baja intacta.
        const aplicadoAhora = !!(finiquito && finiquito.estatus !== "deshecho");
        if (!aplicadoAhora && empleado.fechaBaja) {
          this.cargarPeriodos({ fechaBaja: moment(empleado.fechaBaja) });
        }
      } else {
        message.error(res.data.mensaje || "No se pudieron cargar los datos del empleado");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al cargar los datos del empleado"
      );
    }
    this.setState({ cargando: false });
  }

  // ── Paso 2: periodos elegibles ───────────────────────────────────────────
  /**
   * Consulta ligera — no corre el motor, no crea la prenómina, no escribe nada. Por eso se
   * puede disparar sola cada vez que cambia la fecha de baja, y también después de agregar al
   * empleado a una prenómina.
   *
   * La causa del finiquito NO entra: los periodos elegibles dependen sólo de la fecha.
   */
  cargarPeriodos = async (opciones = {}) => {
    const { empresaId, headersToken } = this.props;
    const { empleadoId } = this.state;
    const fechaBaja = opciones.fechaBaja ?? this.state.fechaBaja;
    if (!empleadoId || !fechaBaja) return;

    this.setState({ cargandoPeriodos: true });
    try {
      const res = await axios.post(
        "nomina/periodosParaFiniquito",
        { empresaId, empleadoId, fechaBaja: fechaBaja.format("YYYY-MM-DD") },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        const periodos = res.data.periodos || [];
        // Si el periodo que ya estaba elegido sigue sirviendo se respeta, para no moverle la
        // selección al usuario sin motivo; si no, se preselecciona el primero utilizable.
        const sigueValido = periodos.some(
          (p) => p._id === this.state.periodoAplicacionId && p.disponible
        );
        this.setState({
          periodos,
          motivoPeriodos: res.data.motivo || null,
          periodoAplicacionId: sigueValido
            ? this.state.periodoAplicacionId
            : periodos.find((p) => p.disponible)?._id || null,
        });
      } else {
        this.setState({ periodos: [], motivoPeriodos: null, periodoAplicacionId: null });
        message.error(res.data.mensaje || "No se pudieron cargar los periodos");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al cargar los periodos"
      );
    }
    this.setState({ cargandoPeriodos: false });
  };

  // ── Dar de baja sin finiquito ────────────────────────────────────────────
  /**
   * La baja sola sólo es segura porque el finiquito tardío existe: un empleado dado de baja
   * sigue entrando por el botón del listado, el selector le ofrece los periodos actuales, y
   * "Deshacer baja" revierte. Si alguna de esas tres se rompiera, esto volvería a dejar gente
   * atorada en estado 2 — que es exactamente por lo que se borró el flujo anterior.
   */
  confirmarBajaSinFiniquito = () => {
    const { empleado, fechaBaja, causaFiniquito } = this.state;
    if (!fechaBaja) {
      message.error("Captura la fecha de baja");
      return;
    }
    Modal.confirm({
      title: "Dar de baja sin finiquito",
      width: 560,
      content: (
        <div>
          <p>
            Se dará de baja a <b>{empleado?.nombre}</b> con fecha{" "}
            <b>{fechaBaja.format("DD/MM/YYYY")}</b>, sin calcular ni pagar finiquito.
          </p>
          <ul style={{ paddingLeft: 18, marginBottom: 8 }}>
            <li>Dejará de entrar a las prenóminas que se generen de aquí en adelante.</li>
            <li>
              <b>No se recalcula ninguna nómina.</b> Se te dirá cuáles quedaron desactualizadas
              para que las recalcules desde Prenómina cuando te toque — hasta entonces siguen
              mostrando el sueldo completo.
            </li>
            <li>
              El finiquito se puede aplicar después desde esta misma pantalla, en un periodo
              actual.
            </li>
          </ul>
          <p style={{ color: "#A32D2D" }}>
            La fecha ya no se podrá cambiar sin cancelar la baja.
          </p>
        </div>
      ),
      okText: "Sí, dar de baja",
      cancelText: "Cancelar",
      onOk: () => this.darDeBaja(causaFiniquito),
    });
  };

  async darDeBaja() {
    const { empresaId, headersToken } = this.props;
    const { empleadoId, fechaBaja, causaFiniquito, motivoBaja } = this.state;

    this.setState({ dandoDeBaja: true });
    try {
      const res = await axios.post(
        "nomina/bajaSinFiniquito",
        {
          empresaId,
          empleadoId,
          fechaBaja: fechaBaja.format("YYYY-MM-DD"),
          causaFiniquito,
          motivoBaja,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(res.data.mensaje || "Empleado dado de baja");
        this.setState({
          porRecalcular: res.data.porRecalcular || [],
          advertencias: res.data.advertencias || [],
          preview: null,
          tab: "1",
        });
        this.cargarDatos();
      } else {
        message.error(res.data.mensaje || "No se pudo dar de baja al empleado");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al dar de baja al empleado"
      );
    }
    this.setState({ dandoDeBaja: false });
  }

  // ── Corregir un periodo donde el empleado no tiene línea ─────────────────
  /**
   * El periodo existe y su prenómina está abierta, pero el empleado no aparece en ella: pasa
   * cuando la prenómina se generó con otro tipo de periodo, o antes de dar de alta al
   * empleado. Se corrige aquí mismo con el endpoint que ya usa la pantalla de Prenómina.
   *
   * Va con confirmación porque toca una prenómina donde hay más gente.
   */
  confirmarAgregarAPrenomina = (periodo) => {
    const { empleado } = this.state;
    Modal.confirm({
      title: "Agregar el empleado a esa prenómina",
      content: (
        <>
          Se creará la línea de <b>{empleado?.nombre}</b> en la prenómina del periodo{" "}
          <b>{`${periodo.serie || ""}-${periodo.numero}`}</b>, que es una prenómina con más
          empleados. La línea entra en ceros hasta que se calcule.
        </>
      ),
      okText: "Agregar",
      cancelText: "Cancelar",
      onOk: () => this.agregarAPrenomina(periodo),
    });
  };

  agregarAPrenomina = async (periodo) => {
    const { empresaId, headersToken } = this.props;
    const { empleadoId } = this.state;

    this.setState({ agregandoALaPrenomina: true });
    try {
      const res = await axios.post(
        "prenomina/agregarEmpleadoPrenomina",
        { empresaId, prenominaId: periodo.prenominaId, empleadoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Empleado agregado a la prenómina");
        // Se recargan los periodos para que el que estaba bloqueado quede disponible, y se
        // deja seleccionado ése — es al que el usuario quería llegar.
        await this.cargarPeriodos();
        this.setState({ periodoAplicacionId: periodo._id });
      } else {
        message.error(res.data.message || "No se pudo agregar el empleado a la prenómina");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Error de conexión al agregar el empleado"
      );
    }
    this.setState({ agregandoALaPrenomina: false });
  };

  // ── Desglose de un finiquito ya aplicado ─────────────────────────────────
  /**
   * Sólo lee: devuelve lo que hay en la línea más la captura del usuario, para poder seguir
   * ajustándola. No corre el motor, así que abrir la pantalla de un finiquito aplicado es barato.
   */
  cargarDesgloseAplicado = async (finiquitoId) => {
    const { empresaId, headersToken } = this.props;
    this.setState({ calculando: true, errorDesglose: null });
    try {
      const res = await axios.post(
        "nomina/desgloseFiniquito",
        { empresaId, finiquitoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        const { captura } = res.data;
        this.setState((prev) => ({
          preview: res.data,
          periodoAplicacionId: res.data.periodoAplicacionId,
          // El selector de periodo se quedaba VACÍO en un finiquito aplicado: `cargarPeriodos`
          // no corre en ese caso, y aunque corriera, un periodo ya usado deja de estar entre los
          // "elegibles" en cuanto su prenómina se cierra. Se siembra con el suyo, que viene en la
          // respuesta, para que al menos se vea en cuál cayó.
          periodos: prev.periodos.length
            ? prev.periodos
            : (res.data.periodo ? [res.data.periodo] : []),
          aniosCompletosIsr: res.data.propuesta?.aniosCompletosIsr ?? null,
          basesFaltantes: res.data.basesFaltantes || [],
          editable: !!res.data.editable,
          fechaPago: res.data.fechaPago ? moment(res.data.fechaPago) : null,
          polizaGenerada: !!res.data.polizaGenerada,
          fechaRegistroPoliza: res.data.fechaRegistroPoliza || null,
          numeroPoliza: res.data.numeroPoliza ?? null,
          // La captura se rehidrata COMPLETA. `editarFiniquito` recibe días, conceptos libres e
          // importes forzados en cada llamada, así que si la pantalla arrancara con ellos vacíos
          // la primera edición los borraría todos.
          conceptos: captura?.conceptos || {},
          extras: captura?.extras || [],
          manuales: captura?.manuales || {},
        }));
      } else {
        // Se guarda en el estado y NO sólo como toast. El desglose puede fallar por siete motivos
        // distintos —la línea borrada, un concepto del catálogo renombrado, el periodo eliminado—
        // y con un aviso que se va en tres segundos la pantalla queda indistinguible de la de un
        // empleado que nunca tuvo finiquito.
        this.setState({ errorDesglose: res.data.mensaje || "No se pudo leer el desglose del finiquito" });
      }
    } catch (error) {
      this.setState({
        errorDesglose: error?.response?.data?.mensaje
          || "Error de conexión al leer el desglose del finiquito",
      });
    }
    this.setState({ calculando: false });
  };

  // ── Fecha de pago ────────────────────────────────────────────────────────
  /**
   * Va por su propio endpoint y NO por `editarFiniquito`: ése revierte la línea y vuelve a correr
   * el motor, así que cambiar la fecha con la que se contabiliza movería los importes de un
   * finiquito ya revisado.
   */
  guardarFechaPago = async (fechaPago) => {
    const { empresaId, headersToken } = this.props;
    const { finiquitoPrevio } = this.state;
    if (!finiquitoPrevio?._id) return;

    try {
      const res = await axios.post(
        "nomina/fechaPagoFiniquito",
        {
          empresaId,
          finiquitoId: finiquitoPrevio._id,
          fechaPago: fechaPago ? fechaPago.format("YYYY-MM-DD") : null,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Fecha de pago guardada");
        this.setState({ advertenciasFechaPago: res.data.advertencias || [] });
      } else {
        message.error(res.data.mensaje || "No se pudo guardar la fecha de pago");
        // El backend rechazó: se recarga para no dejar en pantalla una fecha que no se guardó.
        this.cargarDesgloseAplicado(finiquitoPrevio._id);
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al guardar la fecha de pago"
      );
    }
  };

  /**
   * El punto único por el que pasan TODAS las ediciones de conceptos.
   *
   * Antes de aplicar, previsualiza (`calcularFiniquito`, no escribe). Después de aplicar,
   * ESCRIBE (`editarFiniquito`), como el sobre-recibo de la prenómina. No es una preferencia de
   * diseño: la previsualización inyecta los movimientos por `movimientosSimulados`, y en un
   * finiquito ya aplicado esos MovimientoPermanente existen en la base — simularlos encima
   * contaría los días dos veces.
   */
  recalcular = (opciones = {}) => (
    this.state.aplicado ? this.guardarEdicion(opciones) : this.calcular(opciones)
  );

  // ── Guardar la edición de un finiquito ya aplicado ───────────────────────
  guardarEdicion = async (opciones = {}) => {
    const { empresaId, headersToken } = this.props;
    const {
      finiquitoPrevio, conceptos, extras, manuales, aniosCompletosIsr, motivoBaja, editable,
    } = this.state;
    if (!finiquitoPrevio?._id) return;
    if (!editable) {
      message.info(
        "Este finiquito ya está timbrado. Cancela su recibo desde Prenómina para poder modificarlo."
      );
      return;
    }

    this.setState({ calculando: true });
    try {
      const res = await axios.post(
        "nomina/editarFiniquito",
        {
          empresaId,
          finiquitoId: finiquitoPrevio._id,
          conceptos,
          conceptosExtra: extras,
          manuales,
          aniosCompletosIsr,
          motivoBaja,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        // Igual que en calcular: los capturados se rehidratan desde la respuesta, para que el
        // estado local sea siempre lo que el backend acaba de guardar.
        const capturados = {};
        for (const f of res.data.filas) {
          capturados[f.key] = { aplica: f.aplica, dias: f.diasCapturados };
        }
        this.setState({
          preview: res.data,
          aniosCompletosIsr: res.data.propuesta?.aniosCompletosIsr ?? null,
          basesFaltantes: res.data.basesFaltantes || [],
          conceptos: capturados,
          extras: res.data.captura?.extras || extras,
          manuales: res.data.captura?.manuales || manuales,
          tab: opciones.mantenerTab ? this.state.tab : "2",
        });
      } else {
        message.error(res.data.mensaje || "No se pudo guardar el cambio del finiquito");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al guardar el finiquito"
      );
    }
    this.setState({ calculando: false });
  };

  // ── Paso 3: cálculo (previsualización, no escribe) ───────────────────────
  calcular = async (opciones = {}) => {
    const { empresaId, headersToken } = this.props;
    const {
      empleadoId, fechaBaja, causaFiniquito, aniosCompletosIsr, conceptos, extras, manuales,
    } = this.state;
    const periodoAplicacionId = opciones.periodoAplicacionId ?? this.state.periodoAplicacionId;

    if (!fechaBaja) {
      message.error("Captura la fecha de baja");
      return;
    }

    this.setState({ calculando: true });
    try {
      const res = await axios.post(
        "nomina/calcularFiniquito",
        {
          empresaId,
          empleadoId,
          fechaBaja: fechaBaja.format("YYYY-MM-DD"),
          causaFiniquito,
          periodoAplicacionId,
          aniosCompletosIsr,
          // Sólo se mandan los conceptos si el usuario ya alteró algo; en el primer cálculo
          // se deja que el backend proponga todo.
          conceptos: opciones.conservarCapturados === false ? undefined : conceptos,
          // Los conceptos libres y los importes forzados van en CADA corrida: el backend los
          // vuelve a validar y a aplicar, así que la previsualización no puede divergir de lo
          // que se aplicará.
          conceptosExtra: extras,
          manuales,
        },
        { headers: headersToken }
      );

      if (res.data.success === 2) {
        // Los conceptos capturados se rehidratan desde la respuesta, así el estado local
        // siempre refleja lo que el backend acaba de calcular.
        const capturados = {};
        for (const f of res.data.filas) {
          capturados[f.key] = { aplica: f.aplica, dias: f.diasCapturados };
        }
        this.setState({
          preview: res.data,
          periodos: res.data.periodos || [],
          periodoAplicacionId: res.data.periodoAplicacionId,
          aniosCompletosIsr: res.data.propuesta?.aniosCompletosIsr ?? null,
          basesFaltantes: res.data.basesFaltantes || [],
          conceptos: capturados,
          // El botón Calcular lleva al desglose, que es el resultado que se pidió ver. Un
          // recálculo automático —agregar un concepto, editar un importe— NO mueve de pestaña:
          // el usuario está trabajando en una y arrancarlo a la otra es peor que no avisar nada.
          tab: opciones.mantenerTab ? this.state.tab : "2",
        });
      } else {
        // Los periodos se guardan aunque el cálculo falle: el motivo suele ser justo que
        // ninguno está disponible, y el usuario necesita verlo en el selector.
        if (res.data.periodos) this.setState({ periodos: res.data.periodos });
        if (res.data.conceptosFaltantes) this.setState({ conceptosFaltantes: res.data.conceptosFaltantes });
        message.error(res.data.mensaje || "No se pudo calcular el finiquito");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al calcular el finiquito"
      );
    }
    this.setState({ calculando: false });
  };

  // ── Aplicar ──────────────────────────────────────────────────────────────
  confirmarAplicar = () => {
    const { preview, periodos, periodoAplicacionId, basesFaltantes } = this.state;
    if (!preview) {
      message.info("Primero calcula el finiquito");
      return;
    }
    // Red de seguridad por si el botón se alcanzara de otra forma: el backend también corta.
    if (basesFaltantes.length) {
      message.error(basesFaltantes[0].mensaje);
      return;
    }
    const periodo = periodos.find((p) => p._id === periodoAplicacionId);
    Modal.confirm({
      title: "Aplicar finiquito",
      width: 520,
      content: (
        <div>
          <p>
            Se dará de baja al empleado y los conceptos del finiquito entrarán a su línea en la
            prenómina del periodo{" "}
            <b>
              {periodo ? `${periodo.serie || ""}-${periodo.numero}` : "seleccionado"}
            </b>
            .
          </p>
          <p>
            <b>No se timbra nada todavía.</b> El CFDI se genera cuando cierres y timbres esa
            prenómina, junto con el resto de los empleados.
          </p>
        </div>
      ),
      okText: "Sí, aplicar",
      cancelText: "Cancelar",
      onOk: () => this.aplicar(),
    });
  };

  async aplicar() {
    const { empresaId, headersToken } = this.props;
    const {
      empleadoId, fechaBaja, causaFiniquito, motivoBaja,
      periodoAplicacionId, aniosCompletosIsr, conceptos, extras, manuales, fechaPago,
    } = this.state;

    this.setState({ aplicando: true });
    try {
      const res = await axios.post(
        "nomina/aplicarFiniquito",
        {
          empresaId,
          empleadoId,
          fechaBaja: fechaBaja.format("YYYY-MM-DD"),
          causaFiniquito,
          motivoBaja,
          periodoAplicacionId,
          aniosCompletosIsr,
          conceptos,
          conceptosExtra: extras,
          manuales,
          // La que va a llevar la póliza y el @FechaPago del CFDI. Vacía = la de la prenómina.
          fechaPago: fechaPago ? fechaPago.format("YYYY-MM-DD") : null,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Finiquito aplicado a la prenómina");
        this.setState({
          preview: res.data,
          aplicado: true,
          // Recién aplicado y sin timbrar: se puede seguir ajustando desde aquí mismo.
          editable: true,
          finiquitoPrevio: { _id: res.data.finiquitoId, estatus: "aplicado" },
          // Otras prenóminas que la baja dejó desactualizadas. La del finiquito no entra: ésa
          // acaba de calcularse con sus conceptos.
          porRecalcular: res.data.porRecalcular || [],
          advertencias: res.data.advertencias || [],
          advertenciasFechaPago: res.data.advertenciasFechaPago || [],
        });
      } else {
        message.error(res.data.mensaje || "No se pudo aplicar el finiquito");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al aplicar el finiquito"
      );
    }
    this.setState({ aplicando: false });
  }

  // ── Timbrar ──────────────────────────────────────────────────────────────
  // Dos pasos: primero la validación de datos del empleado (el mismo endpoint y el mismo modal
  // que usa el listado de Empleados), y sólo si pasa se manda a timbrar. Un CFDI emitido ya sólo
  // se puede cancelar, así que no vale la pena descubrir un RFC incompleto por el error del PAC.
  timbrar = async () => {
    const { empresaId, headersToken } = this.props;
    const { empleadoId } = this.state;

    this.setState({ validacion: { visible: true, loading: true, resultados: [] } });
    let validacionOk = false;
    try {
      const res = await axios.post(
        "empleados/validarEmpleadoParaTimbrado",
        { empresaId, empleadoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        const { success, ...resultado } = res.data;
        validacionOk = !!res.data.ok;
        this.setState({
          validacion: { visible: !validacionOk, loading: false, resultados: [resultado] },
        });
        if (!validacionOk) {
          message.error("Al empleado le faltan datos para poder timbrar. Revisa el detalle.");
        }
      } else {
        this.setState({ validacion: { visible: false, loading: false, resultados: [] } });
        message.error(res.data.message || "No se pudo validar al empleado");
      }
    } catch (error) {
      this.setState({ validacion: { visible: false, loading: false, resultados: [] } });
      message.error("Error de conexión al validar al empleado");
    }

    if (!validacionOk) return;

    this.confirmarTimbrar();
  };

  confirmarTimbrar = () => {
    this.setState({ confirmarTimbrado: { visible: true, fecha: fechaEmisionPorDefecto() } });
  };

  async ejecutarTimbrado() {
    const { empresaId, headersToken } = this.props;
    const { finiquitoPrevio, confirmarTimbrado } = this.state;
    if (!finiquitoPrevio?._id) return;

    // Se revalida al confirmar y no sólo al elegirla: entre abrir el modal y
    // darle timbrar puede pasar rato, y la ventana del SAT corre sola.
    const errorEmision = errorFechaEmision(confirmarTimbrado.fecha);
    if (errorEmision) { message.error(errorEmision); return; }

    this.setState({ timbrando: true, confirmarTimbrado: { visible: false, fecha: null } });
    try {
      const res = await axios.post(
        "nomina/timbrarFiniquito",
        {
          empresaId,
          finiquitoId: finiquitoPrevio._id,
          fechaComprobante: formatoFechaEmision(confirmarTimbrado.fecha),
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(res.data.mensaje || "Finiquito timbrado");
        this.setState({
          timbrado: true,
          // El CFDI ya existe ante el SAT: a partir de aquí la línea es inmutable y el desglose
          // queda de sólo lectura hasta que se cancele el recibo.
          editable: false,
          uuid: res.data.uuid || null,
          uuidSeparacion: res.data.uuidSeparacion || null,
          finiquitoPrevio: { ...finiquitoPrevio, estatus: "timbrado" },
        });
        // Y se relee el desglose: timbrar cambia cosas que esta respuesta no trae —la póliza ya
        // existe (con eso se congela la fecha de pago), la línea pasó a 'timbrada' y el desglose
        // se vuelve de sólo lectura—. Sin esto la pantalla quedaba a medias hasta recargarla.
        this.cargarDesgloseAplicado(finiquitoPrevio._id);
      } else {
        // Un rechazo del SAT no cabe en un toast: va al overlay, con el detalle
        // técnico plegado por si hay que copiarlo para soporte.
        MensajeError({
          message: "No se pudo timbrar el finiquito",
          description: res.data.mensaje,
          detalleTecnico: res.data.detalleTecnico,
        });
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al timbrar el finiquito"
      );
    }
    this.setState({ timbrando: false });
  }

  // ── Deshacer ─────────────────────────────────────────────────────────────
  /**
   * Un solo botón para los dos casos, porque para el usuario es la misma intención ("échalo
   * para atrás"). Lo que cambia es qué hay que revertir: con finiquito hay que quitar además
   * sus conceptos de la línea, y eso lo hace deshacerFiniquito. Sin finiquito sólo está la
   * baja, y ésa la revierte cancelarBajaSinFiniquito.
   */
  confirmarDeshacer = () => {
    const { finiquitoPrevio, aplicado } = this.state;
    const conFiniquito = aplicado && !!finiquitoPrevio?._id;

    Modal.confirm({
      title: conFiniquito ? "Deshacer baja y finiquito" : "Cancelar la baja",
      width: 520,
      content: conFiniquito ? (
        <div>
          <p>
            Se quitarán los conceptos del finiquito de la prenómina, se recalculará esa línea y
            el empleado volverá a quedar activo.
          </p>
          <p style={{ color: "#A32D2D" }}>
            Sólo se puede si la línea todavía no está timbrada.
          </p>
        </div>
      ) : (
        <div>
          <p>
            Se borrará la fecha de baja y el empleado volverá a quedar activo.{" "}
            <b>No se recalcula ninguna nómina</b>: se te dirá cuáles quedaron desactualizadas
            para que las recalcules desde Prenómina, y hasta entonces siguen con el sueldo
            recortado.
          </p>
          <p style={{ color: "#A32D2D" }}>
            Si alguna ya se timbró con los días recortados, ese CFDI queda inconsistente y se te
            va a avisar cuál.
          </p>
        </div>
      ),
      okText: conFiniquito ? "Sí, deshacer" : "Sí, cancelar la baja",
      cancelText: "Cerrar",
      onOk: () => (conFiniquito ? this.deshacer() : this.cancelarBaja()),
    });
  };

  async deshacer() {
    const { empresaId, headersToken } = this.props;
    const { finiquitoPrevio } = this.state;
    if (!finiquitoPrevio?._id) return;

    this.setState({ deshaciendo: true });
    try {
      const res = await axios.post(
        "nomina/deshacerFiniquito",
        { empresaId, finiquitoId: finiquitoPrevio._id },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(res.data.mensaje || "Finiquito deshecho");
        this.setState({
          aplicado: false, editable: false, finiquitoPrevio: null, preview: null, conceptos: {},
          extras: [], manuales: {}, tab: "1",
        });
        this.cargarDatos();
      } else {
        message.error(res.data.mensaje || "No se pudo deshacer el finiquito");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al deshacer el finiquito"
      );
    }
    this.setState({ deshaciendo: false });
  }

  async cancelarBaja() {
    const { empresaId, headersToken } = this.props;
    const { empleadoId } = this.state;

    this.setState({ deshaciendo: true });
    try {
      const res = await axios.post(
        "nomina/cancelarBajaSinFiniquito",
        { empresaId, empleadoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(res.data.mensaje || "Baja cancelada");
        this.setState({
          porRecalcular: res.data.porRecalcular || [],
          advertencias: res.data.advertencias || [],
          preview: null, conceptos: {}, extras: [], manuales: {},
          periodos: [], periodoAplicacionId: null, tab: "1",
        });
        this.cargarDatos();
      } else {
        message.error(res.data.mensaje || "No se pudo cancelar la baja");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.mensaje || "Error de conexión al cancelar la baja"
      );
    }
    this.setState({ deshaciendo: false });
  }

  // ── Reingreso ────────────────────────────────────────────────────────────
  /**
   * Tras reingresar, el empleado ya no tiene baja y su finiquito pasó a ser de la relación
   * anterior: `datosParaFiniquito` ya no lo devuelve. Pero `cargarDatos` sólo repone
   * empleado/finiquito/aplicado/timbrado, así que el desglose, la captura y los periodos del
   * finiquito viejo se quedarían en pantalla. Se limpian igual que al deshacer.
   */
  alCerrarReingreso = (reingresado) => {
    this.setState({ reingresoVisible: false });
    if (!reingresado) return;
    this.setState({
      aplicado: false, timbrado: false, editable: false, finiquitoPrevio: null, preview: null,
      conceptos: {}, extras: [], manuales: {}, periodos: [], periodoAplicacionId: null,
      motivoPeriodos: null, basesFaltantes: [], errorDesglose: null, aniosCompletosIsr: null,
      fechaPago: null, polizaGenerada: false, fechaRegistroPoliza: null, numeroPoliza: null,
      advertenciasFechaPago: [], porRecalcular: [], advertencias: [],
      uuid: null, uuidSeparacion: null, tab: "1",
    });
    this.cargarDatos();
  };

  // ── Documentos ───────────────────────────────────────────────────────────
  // Responden los bytes del PDF, no JSON: se abre el blob en una pestaña nueva.
  abrirPdf = async (ruta, nombre) => {
    const { empresaId, headersToken } = this.props;
    const { finiquitoPrevio } = this.state;
    if (!finiquitoPrevio?._id) {
      message.info("El documento se genera cuando el finiquito ya está aplicado");
      return;
    }
    try {
      const res = await axios.post(
        `nomina/${ruta}`,
        { empresaId, finiquitoId: finiquitoPrevio._id },
        { headers: headersToken, responseType: "blob" }
      );
      // Si algo falló, el backend responde JSON en lugar del PDF.
      if (res.data.type === "application/json") {
        const texto = await res.data.text();
        message.error(JSON.parse(texto).mensaje || `No se pudo generar ${nombre}`);
        return;
      }
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url, "_blank");
    } catch (error) {
      message.error(`Error al generar ${nombre}`);
    }
  };

  // ── Cambios en la captura ────────────────────────────────────────────────
  /** El conceptoNominaId de uno de los nueve, para cruzar la captura por días con los manuales. */
  idDeConcepto = (key) => {
    const fila = (this.state.preview?.filas || []).find((f) => f.key === key);
    return fila?.conceptoNominaId ? String(fila.conceptoNominaId) : null;
  };

  cambiarConcepto = (key, cambios, alTerminar) => {
    // Se resuelve ANTES del updater: `idDeConcepto` lee la previsualización, y dentro de un
    // updater no se debe leer this.state.
    const idConDias = cambios.dias !== undefined ? this.idDeConcepto(key) : null;

    this.setState((prev) => {
      const conceptos = {
        ...prev.conceptos,
        [key]: { ...prev.conceptos[key], ...cambios },
      };
      // El séptimo día no tiene interruptor propio: se apaga y se prende con el sueldo, porque
      // se calcula proporcional a los días laborados y no al importe del sueldo. El backend hace
      // lo mismo (CLAVES_APAGADAS_CON_SUELDO); aquí se refleja para que la tabla no muestre el
      // séptimo marcado mientras el sueldo está apagado.
      if (key === "sueldo" && cambios.aplica !== undefined) {
        conceptos.septimoDia = { ...conceptos.septimoDia, aplica: cambios.aplica };
      }

      // Capturar días manda sobre un importe forzado del mismo concepto: gana lo último que se
      // tocó. Sin esto el importe del desglose seguiría ganando (se aplica después en
      // armarConceptoOverrides) y la pantalla mostraría los días nuevos con el importe viejo.
      return idConDias && prev.manuales[idConDias]
        ? { conceptos, manuales: sinLlave(prev.manuales, idConDias) }
        : { conceptos };
    }, alTerminar);
  };

  // ── Conceptos libres ─────────────────────────────────────────────────────
  /**
   * Agregar, quitar o desactivar un concepto SÍ recalcula solo. Cambiar su importe NO — ése sigue
   * la regla de los días, que es la de siempre en esa pestaña: se captura y se presiona Recalcular.
   * La diferencia no es capricho: un renglón que aparece o desaparece del recibo no es un número a
   * medio escribir, y dejarlo invisible hasta el siguiente clic se lee como que no funcionó.
   */
  agregarExtra = (extra) => {
    const id = String(extra.conceptoNominaId);
    if (this.state.extras.some((e) => String(e.conceptoNominaId) === id)) {
      message.info("Ese concepto ya está agregado al finiquito");
      return false;
    }
    this.setState(
      (prev) => ({ extras: [...prev.extras, { ...extra, conceptoNominaId: id, aplica: true }] }),
      () => this.recalcular({ mantenerTab: true })
    );
    return true;
  };

  /**
   * El alta desde el desglose. La tabla de conceptos es la del sobre-recibo y ahí el alta manda
   * `(id, importe)` sueltos; el finiquito guarda además la descripción y el tipo, así que se
   * traduce aquí en vez de meterle una rama al componente compartido.
   */
  agregarExtraDesdeDesglose = (conceptoNominaId, importe, concepto) => this.agregarExtra({
    conceptoNominaId,
    descripcion: concepto?.descripcion || "",
    tipo: concepto?.tipo ?? 1,
    importe,
  });

  /**
   * Quitar uno de los nueve conceptos del finiquito desde el desglose. NO se borra: se desactiva,
   * que es exactamente desmarcar su casilla "Aplica" en la pestaña 1 — el mismo estado, el mismo
   * camino y por lo tanto reversible desde ahí.
   */
  quitarConceptoLey = (key) => {
    this.cambiarConcepto(key, { aplica: false }, () => this.recalcular({ mantenerTab: true }));
  };

  cambiarExtra = (conceptoNominaId, cambios) => {
    const id = String(conceptoNominaId);
    this.setState(
      (prev) => ({
        extras: prev.extras.map((e) => (
          String(e.conceptoNominaId) === id ? { ...e, ...cambios } : e
        )),
        // Mismo criterio que en los días: el importe capturado aquí gana sobre uno forzado antes
        // en el desglose sobre ese mismo concepto.
        manuales: cambios.importe !== undefined ? sinLlave(prev.manuales, id) : prev.manuales,
      }),
      () => { if (cambios.aplica !== undefined) this.recalcular({ mantenerTab: true }); }
    );
  };

  quitarExtra = (conceptoNominaId) => {
    const id = String(conceptoNominaId);
    this.setState(
      (prev) => ({
        extras: prev.extras.filter((e) => String(e.conceptoNominaId) !== id),
        // El importe que se le hubiera forzado se va con él: apuntaría a un concepto que ya no
        // entra a la línea, y el backend lo sembraría de vuelta como un renglón fantasma.
        manuales: sinLlave(prev.manuales, id),
      }),
      () => this.recalcular({ mantenerTab: true })
    );
  };

  // ── Importes forzados en el desglose (edición tipo sobre-recibo) ─────────
  /**
   * Cada edición vuelve a correr el motor. Es UNA línea —el mismo costo que el desglose que ya
   * dispara el sobre-recibo con cada doble clic— y es lo que hace que el ISR de separación, la
   * exención y el neto que se ven sean siempre los que se van a aplicar.
   */
  editarManual = (conceptoNominaId, campo, valor) => {
    const id = String(conceptoNominaId);

    // Editar el VALOR de uno de los nueve conceptos del finiquito es capturar sus DÍAS, así que se
    // manda al mismo estado que la pestaña 1 en lugar de a un manual aparte. Si fueran dos estados
    // distintos, cada pestaña mostraría un número de días y el recibo pagaría el de acá.
    const filaDeLosNueve = campo === "valorManual"
      ? (this.state.preview?.filas || []).find((f) => String(f.conceptoNominaId) === id)
      : null;
    if (filaDeLosNueve) {
      this.cambiarConcepto(
        filaDeLosNueve.key,
        { dias: valor },
        () => this.recalcular({ mantenerTab: true })
      );
      return;
    }

    this.setState(
      (prev) => ({
        manuales: { ...prev.manuales, [id]: { ...prev.manuales[id], [campo]: valor } },
      }),
      () => this.recalcular({ mantenerTab: true })
    );
  };

  limpiarManual = (conceptoNominaId) => {
    const id = String(conceptoNominaId);
    // El sueldo y el séptimo día son el caso especial: su manual puede no venir del desglose sino
    // de los días capturados en la pestaña 1 (armarConceptoOverrides los convierte en
    // días × salario diario). Quitarles el manual sin devolver los días propuestos dejaría la
    // marca azul puesta y el botón pareciendo que no hace nada.
    const filas = this.state.preview?.filas || [];
    const filaDeDias = filas.find(
      (f) => String(f.conceptoNominaId) === id && (f.key === "sueldo" || f.key === "septimoDia")
    );

    this.setState(
      (prev) => ({
        manuales: sinLlave(prev.manuales, id),
        ...(filaDeDias
          ? {
              conceptos: {
                ...prev.conceptos,
                [filaDeDias.key]: {
                  ...prev.conceptos[filaDeDias.key],
                  dias: filaDeDias.diasPropuestos,
                },
              },
            }
          : {}),
      }),
      () => this.recalcular({ mantenerTab: true })
    );
  };

  limpiarTodosManuales = () => {
    const filas = this.state.preview?.filas || [];
    this.setState(
      (prev) => {
        const conceptos = { ...prev.conceptos };
        // Por lo mismo que en limpiarManual: los días capturados de sueldo/séptimo también
        // producen un manual, y si no se devuelven a la propuesta la marca azul se queda puesta.
        for (const f of filas) {
          if (f.key !== "sueldo" && f.key !== "septimoDia") continue;
          conceptos[f.key] = { ...conceptos[f.key], dias: f.diasPropuestos };
        }
        return { manuales: {}, conceptos };
      },
      () => this.recalcular({ mantenerTab: true })
    );
  };

  /**
   * Se dispara al salir del campo de días de Sueldo, no en cada tecla: con `onChange` el modal
   * saltaría a media captura, en cuanto se escribiera el primer dígito.
   *
   * El séptimo día es proporcional a los días laborados —`min(dias × septimoPorDiaSueldo,
   * septimoMaximo)`, que es PARTE_PROPORCIONAL_SEPTIMO_VIGENTE del motor— pero desde que los dos
   * son capturables ya no se deriva solo. Se pregunta en vez de ajustarlo en automático porque
   * hay finiquitos donde el séptimo se pagó aparte o se negoció distinto, y pisarlo en silencio
   * sería justo el tipo de cambio que nadie ve hasta que el recibo está timbrado.
   */
  ofrecerSeptimoProporcional = () => {
    const { conceptos, preview } = this.state;
    const factor = preview?.propuesta?.septimoPorDiaSueldo ?? 0;
    const tope = preview?.propuesta?.septimoMaximo ?? 0;
    if (!factor) return; // periodo sin séptimos o sin días de pago: no hay nada que proponer

    const diasSueldo = Number(conceptos.sueldo?.dias) || 0;
    const actual = Number(conceptos.septimoDia?.dias) || 0;
    const proporcional = Math.round(Math.min(diasSueldo * factor, tope) * 10000) / 10000;
    // Ya coincide (o el usuario no ha tocado nada): no hay por qué interrumpirlo.
    if (Math.abs(proporcional - actual) <= 0.0005) return;

    Modal.confirm({
      title: "¿Ajusto el séptimo día?",
      width: 480,
      okText: `Sí, poner ${proporcional.toFixed(4)}`,
      cancelText: "No, dejarlo en " + actual.toFixed(4),
      content: (
        <div>
          <p>
            Con <b>{diasSueldo.toFixed(4)}</b> días de sueldo, la parte proporcional del séptimo
            día es <b>{proporcional.toFixed(4)}</b>. Hoy tiene <b>{actual.toFixed(4)}</b>.
          </p>
          <p style={{ marginBottom: 0, color: "#888", fontSize: 12 }}>
            Es la misma proporción que usa la nómina ordinaria. Dile que no si el séptimo se pagó
            por otra vía o se negoció distinto. En cualquier caso hay que presionar Recalcular.
          </p>
        </div>
      ),
      onOk: () => this.cambiarConcepto("septimoDia", { dias: proporcional }),
    });
  };

  /**
   * Cambios de la pestaña 1. La fecha de baja y la causa son las dos entradas de las que
   * dependen TODOS los días propuestos, así que al tocarlas se descarta lo capturado: si no,
   * cambiar de "renuncia" a "despido injustificado" dejaría la indemnización en cero, porque
   * se seguirían mandando los días viejos y pisarían la propuesta nueva.
   * Los años completos de ISR se recalculan por el mismo motivo (dependen de la antigüedad).
   */
  cambiarConfiguracion = (cambios) => {
    const reinicia = "fechaBaja" in cambios || "causaFiniquito" in cambios;
    this.setState(
      {
        ...cambios,
        // Cambiar la fecha o la causa invalida lo ya calculado —los días propuestos dependen
        // de las dos—, así que se borra la previsualización en vez de dejar números viejos
        // junto a datos nuevos, y se regresa al paso 1.
        //
        // Los importes forzados se van con ella: un manual es la sustitución de un número que el
        // motor derivó de la fecha y la causa, y dejarlo vivo sobre otra base es justo la clase de
        // discrepancia que nadie encuentra hasta que ya se timbró. Los conceptos LIBRES se
        // conservan: un bono pactado es un hecho capturado que no depende de ninguna de las dos.
        ...(reinicia
          ? { conceptos: {}, manuales: {}, aniosCompletosIsr: null, preview: null, tab: "1" }
          : {}),
      },
      () => {
        // Sólo la fecha cambia qué periodos aplican; la causa no.
        if ("fechaBaja" in cambios) this.cargarPeriodos();
        // La fecha de pago NO entra en `reinicia` —no participa en ningún cálculo, así que
        // cambiarla no puede borrar el desglose— y con el finiquito ya aplicado se guarda sola,
        // por su propio endpoint. Antes de aplicar sólo vive en el estado y viaja en el body.
        if ("fechaPago" in cambios && this.state.aplicado && !this.state.polizaGenerada) {
          this.guardarFechaPago(cambios.fechaPago);
        }
      }
    );
  };

  cambiarPeriodo = (periodoAplicacionId) => {
    // Elegir periodo ya NO calcula: el cálculo es el paso 3 y lo dispara el usuario. Se limpia
    // la previsualización para que no quede en pantalla el resultado de otro periodo, y con ella
    // los importes forzados — el sueldo, el ISR y el IMSS del periodo nuevo son otros números.
    // Los conceptos libres se conservan, por lo mismo que en cambiarConfiguracion.
    this.setState({ periodoAplicacionId, preview: null, manuales: {}, tab: "1" });
  };

  render() {
    const {
      empleado, causas, conceptosFaltantes, basesFaltantes, cargando, calculando, aplicando, deshaciendo,
      fechaBaja, causaFiniquito, motivoBaja, aniosCompletosIsr,
      periodos, periodoAplicacionId, motivoPeriodos, conceptos, extras, preview, aplicado, tab,
      timbrando, timbrado, uuid, uuidSeparacion, validacion, porRecalcular, advertencias,
      cargandoPeriodos, agregandoALaPrenomina, dandoDeBaja, confirmarTimbrado, editable,
      errorDesglose, fechaPago, polizaGenerada, fechaRegistroPoliza, numeroPoliza,
      advertenciasFechaPago,
    } = this.state;

    // Aplicar ya NO congela la pantalla: los importes, los días y los conceptos libres se siguen
    // ajustando hasta que el recibo se timbra —un finiquito casi siempre necesita un retoque
    // después de ver los números—. Cada edición se guarda en firme, igual que en el sobre-recibo
    // de la prenómina. Lo que sí queda fijo desde el momento de aplicar son la captura de la baja
    // y el PERIODO: moverlo es mover la línea a otra prenómina, y para eso está deshacer.
    const bloqueado = aplicado && !editable;
    const periodoBloqueado = aplicado;
    // La fecha de pago tiene un candado propio, y no es el estatus: la contabilización es
    // append-only, así que en cuanto la póliza existe su fecha ya no se puede mover —ni cancelando
    // el CFDI, porque volver a timbrar reusa esa misma póliza—. Al revés, mientras la póliza no
    // exista sigue siendo capturable aunque el finiquito ya esté aplicado y la prenómina cerrada.
    const fechaPagoBloqueada = polizaGenerada;
    // Ya dado de baja pero sin finiquito: es el estado intermedio nuevo. La fecha queda
    // congelada, pero la pantalla sigue viva — se puede calcular, aplicar o cancelar la baja.
    const bajaSola = !!empleado?.fechaBaja && !aplicado;
    // Distinto de `bloqueado`: con baja sola los conceptos siguen siendo editables, sólo la
    // captura de la baja (fecha, causa y motivo) queda fija.
    const fechaBajaBloqueada = aplicado || bajaSola;
    // Paso 3 sólo con un periodo utilizable elegido: sin eso el cálculo iba a fallar de todas
    // formas, y antes lo hacía después de correr media pantalla. Con el finiquito ya aplicado el
    // periodo es el suyo y no hay nada que validar: recalcular es reescribir esa misma línea.
    const periodoElegido = periodos.find((p) => p._id === periodoAplicacionId);
    const puedeCalcular = !!empleado && conceptosFaltantes.length === 0 && (
      aplicado ? editable : !!periodoElegido?.disponible
    );

    return (
      <>
        <PageHeader
          title={`Finiquito${empleado ? ` — ${empleado.nombre}` : ""}`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          // La guía va en el encabezado y no entre las acciones: no es algo que se haga, es algo
          // que se consulta, y ahí se encuentra sin competir con los botones del proceso.
          extra={[
            <ButtonItem
              key="guia"
              blanco
              icon={<QuestionCircleOutlined />}
              onClick={() => this.setState({ guiaVisible: true })}
            >
              Cómo hacerlo
            </ButtonItem>,
          ]}
        />

        {/* Barra de acciones — el equivalente del toolbar de CONTPAQi */}
        <div
          style={{
            background: "white", padding: 12, borderRadius: 6, marginBottom: 10,
            display: "flex", gap: 8, flexWrap: "wrap",
          }}
        >
          <ButtonItem
            type="primary"
            loading={calculando}
            disabled={!puedeCalcular}
            onClick={() => this.recalcular()}
          >
            {aplicado ? "Recalcular y guardar" : (preview ? "Recalcular" : "Calcular")}
          </ButtonItem>
          {/* Con bases faltantes se apaga a propósito: aplicar escribe un snapshot inmutable, y
              un finiquito guardado en 0.00 sólo se arregla deshaciéndolo. La alerta de abajo
              dice qué falta. Calcular sí se deja, que es como se ve el problema. */}
          <ButtonItem
            type="primary"
            loading={aplicando}
            disabled={bloqueado || !preview || basesFaltantes.length > 0}
            onClick={this.confirmarAplicar}
          >
            Aplicar finiquito
          </ButtonItem>
          <ButtonItem
            loading={dandoDeBaja}
            disabled={bloqueado || bajaSola || !empleado}
            onClick={this.confirmarBajaSinFiniquito}
          >
            Dar de baja (sin finiquito)
          </ButtonItem>
          <ButtonItem
            type="primary"
            azul
            loading={timbrando}
            disabled={!aplicado || timbrado}
            onClick={this.timbrar}
          >
            {timbrado ? "Timbrado" : "Timbrar"}
          </ButtonItem>
          {/* Cancelar el timbrado sin salir de aquí. Reusa el modal y el endpoint de Prenómina,
              que ya cancelan los DOS CFDI de un finiquito partido y revierten acumulados,
              créditos y contabilidad. Al terminar, el finiquito vuelve a quedar editable. */}
          {timbrado && (
            <ButtonItem
              danger
              disabled={!preview?.lineaId}
              onClick={() => this.setState({ cancelarVisible: true })}
            >
              Cancelar timbrado
            </ButtonItem>
          )}
          {/* El recibo de nómina propiamente dicho, con su XML. Se habilita en cuanto hay línea,
              no sólo al timbrar: sin timbre sale con la marca de agua "VISTA PREVIA - SIN
              TIMBRAR", que es justo lo que sirve para revisarlo antes de emitirlo. */}
          <ButtonItem
            disabled={!preview?.lineaId}
            onClick={() => this.setState({ reciboVisible: true })}
          >
            Recibo (PDF / XML)
          </ButtonItem>
          <ButtonItem
            disabled={!aplicado}
            onClick={() => this.abrirPdf("cartaFiniquitoPdf", "la carta de finiquito")}
          >
            Carta Finiquito
          </ButtonItem>
          <ButtonItem
            disabled={!aplicado}
            onClick={() => this.abrirPdf("hojaTrabajoFiniquitoPdf", "la hoja de trabajo")}
          >
            Hoja de Trabajo
          </ButtonItem>
          <ButtonItem
            danger
            loading={deshaciendo}
            disabled={(!aplicado && !bajaSola) || !!preview?.deRelacionAnterior}
            onClick={this.confirmarDeshacer}
          >
            {aplicado ? "Deshacer Baja/Finiquito" : "Deshacer baja"}
          </ButtonItem>
          {/* Deshacer es para un error (borra la baja como si nunca se hubiera ido); Reingresar es
              para quien volvió a trabajar: reactiva al mismo empleado y deja la baja y el
              finiquito como historia. Los candados (recibos sin timbrar, fecha mínima) los
              decide el backend y el modal los pinta. */}
          {this.props.permisoDeshabilitarEmpleado && (
            <ButtonItem
              verde
              disabled={!empleado?.fechaBaja}
              onClick={() => this.setState({ reingresoVisible: true })}
            >
              Reingresar
            </ButtonItem>
          )}
          <div style={{ flex: 1 }} />
          <ButtonItem onClick={() => this.props.history.goBack()}>Cerrar</ButtonItem>
        </div>

        {/* Un finiquito de antes de un reingreso: es historia de la relación anterior. El backend
            ya rechaza editarlo, deshacerlo y timbrarlo; aquí sólo se dice por qué. */}
        {preview?.deRelacionAnterior && (
          <Alert
            style={{ marginBottom: 10 }}
            type="info"
            showIcon
            message={`El empleado reingresó el ${fmtFechaDia(preview.fechaReingresoPosterior)}`}
            description="Este finiquito es de su relación laboral anterior y es de sólo lectura: ya no se edita, no se deshace y no se vuelve a timbrar."
          />
        )}

        {/* Estado intermedio: dado de baja, sin finiquito. La pantalla sigue viva y hay que
            decir qué se puede hacer desde aquí. */}
        {bajaSola && (
          <Alert
            style={{ marginBottom: 10 }}
            type="info"
            showIcon
            message={`Este empleado está dado de baja el ${fechaBaja ? fechaBaja.format("DD/MM/YYYY") : ""}, sin finiquito aplicado`}
            description={
              <div>
                <p style={{ marginBottom: 4 }}>
                  La fecha, la causa y el motivo quedaron fijos. Para cambiarlos usa{" "}
                  <b>Deshacer baja</b>.
                </p>
                <p style={{ marginBottom: 0 }}>
                  El selector de periodos incluye el periodo actual y los dos siguientes. Si
                  eliges uno posterior al de la baja, el sueldo y el séptimo día salen en cero:
                  el empleado ya no laboró ningún día de ese periodo.
                </p>
              </div>
            }
          />
        )}

        {(porRecalcular.length > 0 || advertencias.length > 0) && (
          <Alert
            style={{ marginBottom: 10 }}
            type="warning"
            showIcon
            closable
            onClose={() => this.setState({ porRecalcular: [], advertencias: [] })}
            message="Hay prenóminas que quedaron desactualizadas por el cambio de baja"
            description={
              <div>
                {porRecalcular.length > 0 && (
                  <>
                    <p style={{ marginBottom: 4 }}>
                      <b>Recalcúlalas desde Prenómina</b> cuando te toque. Mientras tanto siguen
                      mostrando los importes anteriores:
                    </p>
                    <ul style={{ paddingLeft: 18, marginBottom: 8 }}>
                      {porRecalcular.map((p) => (
                        <li key={String(p.prenominaId)}>
                          <b>{p.nombre || String(p.prenominaId)}</b> ({p.estatus})
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {advertencias.length > 0 && (
                  <>
                    <p style={{ marginBottom: 4 }}>
                      Éstas ya no se arreglan recalculando — están cerradas o timbradas. Revísalas
                      a mano:
                    </p>
                    <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                      {advertencias.map((a) => (
                        <li key={String(a.prenominaId)}>
                          <b>{a.nombre || String(a.prenominaId)}</b> ({a.estatus}) — {a.motivo}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            }
          />
        )}

        {/* El finiquito existe pero su desglose no se pudo leer. Sin este aviso la pantalla se
            ve igual que la de un empleado sin finiquito, y el usuario reporta "no me sale su
            finiquito" sin ninguna pista de por qué. */}
        {errorDesglose && (
          <Alert
            style={{ marginBottom: 10 }}
            type="error"
            showIcon
            message="Este empleado sí tiene un finiquito, pero no se pudo mostrar"
            description={
              <div>
                <p style={{ marginBottom: 4 }}>{errorDesglose}</p>
                <p style={{ marginBottom: 0, color: "#888" }}>
                  El finiquito sigue guardado. Las causas más comunes son que se quitó al empleado
                  de la prenómina donde se aplicó, o que se renombró o deshabilitó uno de los
                  conceptos de nómina que usa.
                </p>
              </div>
            }
          />
        )}

        {conceptosFaltantes.length > 0 && (
          <Alert
            style={{ marginBottom: 10 }}
            type="error"
            showIcon
            message="Faltan conceptos de nómina para poder calcular el finiquito"
            description={
              <div>
                <p style={{ marginBottom: 4 }}>
                  No están dados de alta en el catálogo de esta empresa:{" "}
                  <b>{conceptosFaltantes.join(", ")}</b>
                </p>
                <p style={{ marginBottom: 0 }}>
                  Córrelos desde Configuración de Nómina → Abrir asistente de configuración, en
                  el paso de conceptos de ley.
                </p>
              </div>
            }
          />
        )}

        {/* Faltan datos en la ficha del empleado. El cálculo SÍ corre —por eso esta alerta
            aparece junto al resultado y no en lugar de él— pero devuelve importes en 0.00 con
            los días bien calculados, que es exactamente lo que parece un finiquito que "no
            aplicó". Se dice aquí para que no haya que descubrirlo leyendo el desglose.
            Va amarrada a `preview` porque es una afirmación sobre un cálculo concreto: al
            cambiar la fecha, la causa o el periodo se descarta la previsualización y esto se
            tiene que ir con ella en vez de quedarse hablando de números que ya no están. */}
        {preview && basesFaltantes.length > 0 && (
          <Alert
            style={{ marginBottom: 10 }}
            type="error"
            showIcon
            message="Faltan datos del empleado: el finiquito se calcularía en ceros"
            description={
              <div>
                {basesFaltantes.map((b) => (
                  <p key={b.campo} style={{ marginBottom: 4 }}>
                    {b.mensaje}
                  </p>
                ))}
                <p style={{ marginBottom: 0 }}>
                  Captúralos en <b>Empleados → Editar empleado</b> y vuelve a calcular. Mientras
                  tanto <b>Aplicar finiquito</b> queda deshabilitado, porque lo que se guardaría
                  es un finiquito en 0.00 que sólo se puede corregir deshaciéndolo.
                </p>
              </div>
            }
          />
        )}

        {aplicado && !timbrado && (
          <Alert
            style={{ marginBottom: 10 }}
            type="success"
            showIcon
            message="Finiquito aplicado"
            description={
              <div>
                <p style={{ marginBottom: 4 }}>
                  Los conceptos ya están en la línea del empleado, sin timbrar. Puedes timbrarlo
                  aquí mismo con el botón <b>Timbrar</b>, o dejarlo y que se timbre junto con el
                  resto de la prenómina.
                </p>
                {editable ? (
                  <p style={{ marginBottom: 0 }}>
                    <b>Se puede seguir ajustando.</b> Los días, los conceptos libres y los importes
                    de las dos pestañas siguen siendo editables, y cada cambio se guarda en firme
                    sobre la línea — como en el sobre-recibo de la prenómina. La fecha de baja, la
                    causa y el periodo sí quedaron fijos: para cambiarlos hay que deshacer.
                  </p>
                ) : (
                  <p style={{ marginBottom: 0 }}>
                    El desglose está de sólo lectura porque su línea ya no admite cambios (está
                    timbrada, es de una nómina histórica, o su prenómina no lo permite).
                  </p>
                )}
              </div>
            }
          />
        )}

        {timbrado && (
          <Alert
            style={{ marginBottom: 10 }}
            type="success"
            showIcon
            message="Finiquito timbrado"
            description={
              <div>
                {uuid && (
                  <p style={{ marginBottom: 4 }}>
                    UUID{uuidSeparacion ? " (recibo ordinario)" : ""}: <b>{uuid}</b>
                  </p>
                )}
                {/* El segundo comprobante. Los pagos por separación se timbran aparte con régimen
                    13 porque el SAT no permite mezclarlos con los conceptos ordinarios. */}
                {uuidSeparacion && (
                  <p style={{ marginBottom: 4 }}>
                    UUID (indemnización o separación, régimen 13): <b>{uuidSeparacion}</b>
                  </p>
                )}
                <p style={{ marginBottom: 0 }}>
                  Esta línea ya es inmutable: el recálculo la omite, no se puede editar, y al
                  timbrar la prenómina no se vuelve a timbrar. Para corregirla hay que cancelar
                  {uuidSeparacion ? " sus CFDI" : " su CFDI"} desde Prenómina
                  {uuidSeparacion ? " — la cancelación de la línea los cancela juntos." : "."}
                </p>
              </div>
            }
          />
        )}

        {aplicado && (preview?.filas || []).some((f) => f.sinCuentas) && (
          <Alert
            style={{ marginBottom: 10 }}
            type="warning"
            showIcon
            message="Hay conceptos sin cuentas contables"
            description={
              "Al timbrar, la póliza va a salir incompleta: los conceptos sin cuenta se omiten. "
              + "Asígnalas desde Configuración de Nómina → asistente, en el paso de configuración "
              + "contable. El timbrado del CFDI no se afecta."
            }
          />
        )}

        <Spin spinning={cargando}>
          <Tabs
            activeKey={tab}
            onChange={(t) => this.setState({ tab: t })}
            type="card"
            style={{ background: "white", padding: 12, borderRadius: 6 }}
          >
            <TabPane tab="1. Finiquito" key="1">
              <ConfiguracionFiniquito
                empleado={empleado}
                causas={causas}
                fechaBaja={fechaBaja}
                causaFiniquito={causaFiniquito}
                motivoBaja={motivoBaja}
                aniosCompletosIsr={aniosCompletosIsr}
                propuesta={preview?.propuesta}
                filas={preview?.filas}
                conceptos={conceptos}
                periodos={periodos}
                periodoAplicacionId={periodoAplicacionId}
                motivoPeriodos={motivoPeriodos}
                cargandoPeriodos={cargandoPeriodos}
                agregandoALaPrenomina={agregandoALaPrenomina}
                bloqueado={bloqueado}
                periodoBloqueado={periodoBloqueado}
                fechaBajaBloqueada={fechaBajaBloqueada}
                fechaPago={fechaPago}
                fechaPagoBloqueada={fechaPagoBloqueada}
                fechaRegistroPoliza={fechaRegistroPoliza}
                numeroPoliza={numeroPoliza}
                advertenciasFechaPago={advertenciasFechaPago}
                extras={extras}
                filasExtra={preview?.filasExtra}
                conceptosLinea={preview?.conceptosLinea}
                // Para que el selector de conceptos libres no ofrezca el ISR de finiquito, que
                // el backend rechaza y que no está en `filas`.
                isrFiniquitoConceptoId={preview?.isrFiniquitoConceptoId}
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                onCambio={this.cambiarConfiguracion}
                onCambiarConcepto={this.cambiarConcepto}
                onSueldoCapturado={this.ofrecerSeptimoProporcional}
                onCambiarPeriodo={this.cambiarPeriodo}
                onAgregarAPrenomina={this.confirmarAgregarAPrenomina}
                onAgregarExtra={this.agregarExtra}
                onCambiarExtra={this.cambiarExtra}
                onQuitarExtra={this.quitarExtra}
              />
            </TabPane>
            <TabPane tab="2. Percepciones y Deducciones" key="2">
              <DesgloseFiniquito
                preview={preview}
                calculando={calculando}
                bloqueado={bloqueado}
                extras={extras}
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                onEditarManual={this.editarManual}
                onLimpiarManual={this.limpiarManual}
                onQuitarExtra={this.quitarExtra}
                onAgregarExtra={this.agregarExtraDesdeDesglose}
                onQuitarConceptoLey={this.quitarConceptoLey}
                onLimpiarTodos={this.limpiarTodosManuales}
              />
            </TabPane>
          </Tabs>
        </Spin>

        <GuiaFiniquito
          visible={this.state.guiaVisible}
          onClose={() => this.setState({ guiaVisible: false })}
        />

        <ModalReingreso
          visible={this.state.reingresoVisible}
          empleadoId={this.state.empleadoId}
          onCerrar={this.alCerrarReingreso}
        />

        {/* Vista previa del recibo, su XML y —si el finiquito se partió— el selector entre el
            comprobante ordinario y el de separación. Es el mismo visor de Prenómina, así que el
            PDF es byte por byte el que se manda por correo y el que va en el ZIP. */}
        <ModalReciboNomina
          visible={this.state.reciboVisible}
          lineaId={preview?.lineaId}
          onClose={() => this.setState({ reciboVisible: false })}
        />

        {/* El mismo modal de cancelación de Prenómina, con el mismo endpoint. Cancela los dos
            CFDI si el finiquito se partió, revierte acumulados, créditos y ajuste al neto, y
            cancela su póliza contable. Después el finiquito queda aplicado y editable otra vez. */}
        <CancelarCfdiNomina
          visible={this.state.cancelarVisible}
          lineaId={preview?.lineaId}
          nombreEmpleado={empleado?.nombre}
          prenominaId={preview?.prenominaId}
          esFiniquito
          cerrar={() => this.setState({ cancelarVisible: false })}
          onCancelado={() => {
            this.setState({ cancelarVisible: false });
            // Se recarga todo: cambian el estatus, `editable`, y la fecha de pago vuelve a ser
            // capturable porque su póliza ya no existe.
            this.cargarDatos();
          }}
        />

        {/* El mismo modal del listado de Empleados: sólo se abre cuando la validación falla,
            para mostrar qué le impide timbrar. Si pasa, se timbra sin interrumpir. */}
        <ModalValidacionTimbrado
          visible={validacion.visible}
          loading={validacion.loading}
          resultados={validacion.resultados}
          titulo="Datos que faltan para timbrar el finiquito"
          onCancel={() =>
            this.setState({ validacion: { visible: false, loading: false, resultados: [] } })
          }
        />

        {/* Confirmación del timbrado. Además del aviso de siempre pide la fecha de
            emisión del CFDI: el SAT la acepta hasta 72 h atrás y por omisión es
            "ahora", así que no hay que tocarla en el caso normal. */}
        <Modal
          visible={confirmarTimbrado.visible}
          onCancel={() => this.setState({ confirmarTimbrado: { visible: false, fecha: null } })}
          title="Timbrar finiquito"
          width={520}
          footer={[
            <ButtonItem
              key="cancel"
              onClick={() => this.setState({ confirmarTimbrado: { visible: false, fecha: null } })}
            >
              Cancelar
            </ButtonItem>,
            <ButtonItem
              key="confirm"
              rojo
              disabled={!confirmarTimbrado.fecha}
              onClick={() => this.ejecutarTimbrado()}
            >
              Sí, timbrar
            </ButtonItem>,
          ]}
        >
          {preview?.seDivideElCfdi ? (
            <p>
              Se van a generar <b>dos CFDI de nómina</b> de este finiquito: uno con los conceptos
              ordinarios y otro con los pagos por separación (indemnización, prima de antigüedad)
              y su ISR, con <b>tipo de régimen 13</b> y nómina extraordinaria. La guía de llenado
              del SAT no permite que unos y otros vayan en el mismo complemento. En la pestaña de
              percepciones y deducciones se ve qué va en cada uno.
            </p>
          ) : (
            <p>Se va a generar el CFDI de nómina de este finiquito.</p>
          )}
          <p>
            Sólo se timbra <b>esta línea</b>: los demás empleados de la prenómina quedan intactos y
            se siguen calculando y editando normal. Al timbrar la prenómina después, esta línea se
            omite sola.
          </p>
          <p style={{ color: "#A32D2D" }}>
            Un CFDI emitido ya sólo se puede cancelar, no corregir.
          </p>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Fecha de emisión del CFDI</div>
            <SelectorFechaEmision
              value={confirmarTimbrado.fecha}
              onChange={(fecha) => this.setState({ confirmarTimbrado: { visible: true, fecha } })}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  // El mismo que abre esta pantalla desde el listado de Empleados.
  permisoDeshabilitarEmpleado:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "675096f0798d4e0043687257",
    )?.activado,
});

export default connect(mapStateToProps)(Finiquito);
